import { createFileRoute } from '@tanstack/react-router';
import { MethodLayout } from '../../layouts/Method/MethodLayout';

export const Route = createFileRoute('/$retailer/method')({
  component: MethodLayout,
});
